import Vue from "vue";
import VueRouter from "vue-router";
import ContractSelection from "../views/ContractSelection.vue";

Vue.use(VueRouter);

const routes = [
    {
      path: "/",
      name: "contractselection",
      component: ContractSelection
    }
];

const router = new VueRouter({
  routes,
    //mode:'history'
});

export default router;
